import { useQuery } from "@tanstack/react-query";
import { api } from "../api";
import { Layout } from "../components/Layout";
import { useReveal } from "../useReveal";

export default function Haberler() {
  const { data: haberler = [], isLoading } = useQuery({
    queryKey: ["news"], queryFn: async () => (await api.get("/news")).data,
  });
  useReveal(!isLoading);
  return (
    <Layout>
      <section className="sayfa-basi">
        <div className="veri bel">Haberler</div>
        <h1 className="h-dev bel" style={{ margin: "14px 0 30px" }}>Duyurular</h1>
        {isLoading ? <p className="veri">Yükleniyor…</p> : haberler.length === 0 ? (
          <p className="veri">Henüz haber yayınlanmadı.</p>
        ) : (
          <div className="haber-liste bel">
            {haberler.map((h) => (
              <a key={h.id} href="#" onClick={(e) => e.preventDefault()} data-testid={`haber-${h.slug}`}>
                <div>
                  <h3>{h.baslik}</h3>
                  <p>{h.ozet}</p>
                </div>
                <span className="veri">{h.tarih}</span>
              </a>
            ))}
          </div>
        )}
      </section>
    </Layout>
  );
}
